import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/academy")({
  beforeLoad: () => {
    throw redirect({
      to: "/home/academy",
    });
  },
});
